/**
 * Attendance setup is enforced only inside the Attendance module (see AttendanceLayout).
 * This guard no longer redirects dashboard, payroll, or other modules.
 */
export default function WfSetupGuard({ children }) {
  return children;
}
